module.exports = __webpack_public_path__ + "img/duplicar.4d2a9858.svg";